import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportSection',
  props: {
    classNames: null
  },
  setup(__props: any) {

const props = __props as {
  classNames?: string;
};



return { __sfc: true,props }
}

})